export const getProfileType = (label: string) => {
  const profileTypes = {
    CUSTOM: 'Customizado',
    HIERARCHICAL: 'Hierárquico'
  }

  return profileTypes[label as keyof typeof profileTypes] || label
}
